import { Grid } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import EnglishFormActionSection from "../../../Components/UI/EnglishFormActionSection/EnglishFormActionSection";
import FormContainer from "../../../Components/UI/FormContainer/FormContainer";
import SimpleInput from "../../../Components/UI/SimpleInput/SimpleInput";
import useHttpFetch from "../../../hooks/useHttpFetch";
import post from "../../../utils/apiCalls/post";
import validate from "../../../utils/validations/validate";
import classes from "./ForgetPassword.module.css";

const validateForm = (state, setFormValidity) => {
  const oldPasswordVali = validate(state.oldPassword, "securedPassword", null, null, true);
  let firstEntredNewPasswordVali = validate(
    state.firstEntredNewPassword,
    "securedPassword",
    null,
    null,
    true
  );
  let secondEnteredNewPasswordVali = validate(
    state.secondEnteredNewPassword,
    "securedPassword",
    null,
    null,
    true
  );
  if (firstEntredNewPasswordVali.isValid && secondEnteredNewPasswordVali.isValid) {
    if (state.firstEntredNewPassword !== state.secondEnteredNewPassword) {
      firstEntredNewPasswordVali = { isValid: false, msg: "New passwords must be Identical" };
      secondEnteredNewPasswordVali = { isValid: false, msg: "New passwords must be Identical" };
    }
  }

  setFormValidity({
    oldPassword: { ...oldPasswordVali },
    firstEntredNewPassword: { ...firstEntredNewPasswordVali },
    secondEnteredNewPassword: { ...secondEnteredNewPasswordVali },
  });
  const datasAreValid =
    oldPasswordVali.isValid &&
    firstEntredNewPasswordVali.isValid &&
    secondEnteredNewPasswordVali.isValid;

  return datasAreValid;
};

const ForgetPassword = () => {
  const [state, setState] = useState({
    oldPassword: null,
    firstEntredNewPassword: null,
    secondEnteredNewPassword: null,
  });
  const [formValidity, setFormValidity] = useState({
    oldPassword: { isValid: true, msg: "" },
    firstEntredNewPassword: { isValid: true, msg: "" },
    secondEnteredNewPassword: { isValid: true, msg: "" },
  });
  const navigate = useNavigate();
  const { isLoading: actionIsHappening, sendRequest: actionFetch } = useHttpFetch();

  const stateChangeHandler = (e) => setState((ps) => ({ ...ps, [e.target.name]: e.target.value }));
  const validateHandler = (e) => {
    const passwordValidityObj = validate(e.target.value, "securedPassword", null, null, true);
    setFormValidity((ps) => ({ ...ps, [e.target.name]: passwordValidityObj }));
  };
  const cancelHandler = () => navigate("/admin-home-page");
  const submitFormHandler = async () => {
    const datasAreValid = validateForm(state, setFormValidity);
    await post({
      actionFetch,
      data: state,
      urlMainEntity: "ChangePassword",
      datasAreValid,
      forceLtr: true,
      noMiddleUrl: true,
    });
  };

  return (
    <FormContainer addText="Change Password" forceLtr={true} isLoading={actionIsHappening}>
      <Grid container item xs={12}>
        <Grid container item xs={12}>
          <Grid item xs={12} md={4} className={classes.inputContainer}>
            <SimpleInput
              validityName={formValidity.oldPassword}
              value={state.oldPassword}
              onChange={stateChangeHandler}
              onBlur={validateHandler}
              iName="oldPassword"
              label="Old password"
              type="password"
              showPasswordIcon={true}
              maxLength={200}
              isMandatory={true}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid container item xs={12} md={6}>
            <Grid item xs={12} md={8} className={classes.inputContainer}>
              <SimpleInput
                validityName={formValidity.firstEntredNewPassword}
                value={state.firstEntredNewPassword}
                onChange={stateChangeHandler}
                onBlur={validateHandler}
                iName="firstEntredNewPassword"
                label="First entered new password"
                type="password"
                showPasswordIcon={true}
                maxLength={200}
                isMandatory={true}
              />
            </Grid>
            <Grid item xs={12} md={8} className={classes.inputContainer}>
              <SimpleInput
                validityName={formValidity.secondEnteredNewPassword}
                value={state.secondEnteredNewPassword}
                onChange={stateChangeHandler}
                onBlur={validateHandler}
                iName="secondEnteredNewPassword"
                label="Second entered new password"
                type="password"
                showPasswordIcon={true}
                maxLength={200}
                isMandatory={true}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} md={5}>
            <Grid item xs={12} md={9} className={[classes.helperText].join(" ")}>
              Use at least 10 characters, mixed of lowercase letters, uppercase letters and numbers for
              your password
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <EnglishFormActionSection cancelHandler={cancelHandler} submitFormHandler={submitFormHandler} />
    </FormContainer>
  );
};

export default ForgetPassword;
